import React from 'react'
import cn from 'classnames'
import { Button, Checkbox } from '@mc/design-system'
import classes from './CheckboxSelection.module.scss'

type CheckboxSelectionProps = {
  checked: boolean
  onClick(): void
  children: React.ReactNode
  textCls?: string
}

export const CheckboxSelection = ({
  checked,
  onClick,
  children,
  textCls = '',
}: CheckboxSelectionProps) => (
  <Button
    kind='secondary'
    aria-checked={checked}
    fullWidth
    className={cn(
      classes.selection,
      checked && classes.checked,
      // ** full width **
      'mc-px-4', // E/W  16px (scale-4) (all breaks)
      'mc-py-3', // normal (V2)  N/S 12px (scale-3) (all breaks)
      classes.fullWidth, // the checkbox has 16px padding for full width
      'justify-content-start', // left align the button text
      'mc-corners--0', // full width has rounded corners on the button group, not the individual buttons
      textCls,
    )}
    onClick={onClick}
  >
    <Checkbox checked={checked} />
    {children}
  </Button>
)

export const CheckboxSelectionTight = ({
  checked,
  onClick,
  children,
}: CheckboxSelectionProps) => (
  <Button
    kind='secondary'
    aria-checked={checked}
    fullWidth
    className={cn(
      classes.selection,
      checked && classes.checked,
      // ** full width **
      'mc-px-4', // E/W  16px (scale-4) (all breaks)
      'mc-py-sm-3 mc-py-2', // tight (PALM) N/S 8px (scale-2) xs // 12px (scale-3) sm
      classes.fullWidth, // the checkbox has 16px padding for full width
      'justify-content-start', // left align the button text
      'mc-corners--0', // full width has rounded corners on the button group, not the individual buttons
    )}
    onClick={onClick}
  >
    <Checkbox checked={checked} />
    {children}
  </Button>
)
